@if (topbarService.template) {
  <nav class="topbar bg-white box-shadow-sm border-bottom">
    <div class="{{ containerClass }}">
      <ng-container *ngTemplateOutlet="topbarService.template">
      </ng-container>
    </div>
  </nav>
}